
<template>
  <div class="box" >
    <!-- {{answerSheet}}{{selXx}}{{sinAnswer}} -->

    <div class="content-body" >
      <div class="left fl">
        <div class="waste-time pos">
          <div class="tit" style="left: 54px;color:#fff;">剩余时间</div>
          <span class="countdown">{{minutes}}分{{second}}秒</span>
        </div>
        <div class="user-info pos">
          <!-- <div class="tit" style="left: 54px;">考生信息</div> -->
          <div class="imgCon">
            <img :src="!user.headUrl?headUrl:minioUrl+user.headUrl" class="img1">
          </div>
          <!-- <img src="http://j2.58cdn.com.cn/jxedt/m/kaoshi/images/face_nomal.png" alt=""> -->
          <p><span>姓名：</span> <span>{{user.realName}}</span></p>
          <p><span>所属机构：</span> <span>{{user.deptName}}</span></p>
          <p><span>考试时间：</span> <span>{{allData.duration}}分钟</span></p>
          <p><span>总分：</span> <span>{{allData.totalPoint}}分</span></p>

          <!-- <p><label for="">考试类型：</label> <span>{{ksType}}</span></p> -->
          <!-- <p><label for="">考试课程：</label> <span>{{tName}}</span></p> -->
        </div>

      </div>
      <div class="center fl" v-for="(item,index) in allData.questionList" v-show="num==index" :key="index">
        <div class="kstm pos">
          <!-- <div class="tit">考试题目</div> -->
          <p class="name">
            <el-tag effect="plain" :type="tagFomate(item.questionType)" class="tag" size="small">{{queFomate(item.questionType)}}</el-tag>&emsp;{{index+1}}、{{item.name}}
          </p>
          <div class="option">
            <p class="op-item" v-for="(item2,index2) in item.contentMap" :key="index2">{{item2.name}}：{{item2.value}}</p>
          </div>
          <div class="tm-answer">
            <!-- <div class="fl sec-aswer">您的选项是：</div> -->
            <div class=" aswer"><span class="fl">请选择：</span>
              <li v-if="item.questionType == '3'">
                <div @click="queryAnswer(index,item,'T')" :class="'T' == sinAnswer?'xuanSel':''">正确</div>
              </li>
              <li v-if="item.questionType == '3'">
                <div @click="queryAnswer(index,item,'F')" :class="'F' == sinAnswer?'xuanSel':''">错误</div>
              </li>
              <li anser="1" v-else v-for="(item3,index3) in item.contentMap" :key="index3">
                <div @click="queryAnswer(index,item,item3.name)" :class="sinAnswer.indexOf(item3.name) > -1?'xuanSel':''" v-if="item.questionType == '1'">{{item3.name}}</div>
                <div @click="queryAnswer(index,item,item3.name)" :class="sinAnswer.indexOf(item3.name) !== -1?'xuanSel':''" v-if="item.questionType == '2'">{{item3.name}}</div>
              </li>
            </div>
          </div>
          <div class="btn-wrap fl">
            <a href="javascript:" class="btn next" @click="next" v-if="sinAnswer.length>0&&!isEndt">确定答案</a>
            <a href="javascript:" class="btn jj" @click="next" v-if="sinAnswer.length>0&&isEndt">交卷</a>
          </div>
        </div>
        <!-- <div class="tsxx pos fl">
          <div class="tit">提示信息</div>
          <span class="tsxxt">{{item.analysis}}</span>
        </div> -->

      </div>
      <!-- <div class="right fl">
        <div class="Qn-wrap">
          <li :data-order="index" :class="index==num?'qn noSel active':'qn noSel'" v-for="(item,index) in allData.questionList" :key="index">
            <p :style="index<num?'color:#409EFF;':''">{{index+1}}</p>
          </li>
        </div>
      </div> -->
    </div>
    <el-dialog :visible.sync="visible"  class="dia" width='400px' :show-close='false' :close-on-click-modal='false' :close-on-press-escape='false'>
      <div style="text-align:center;" v-loading='answerLoading'>
        <img v-if="istrue" src="@/assets/img/success.png" alt="">
        <img v-else src="@/assets/img/error.png" alt="">
        <div style="margin-top:14px;">
          <span class="tip" style="color:#09BB07;" v-if="istrue">回答正确</span>
          <span class="tip" style="color:#F25858;" v-else>回答错误</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer btn-wrap" v-if="!answerLoading">
        <el-button class="btn next elb" :loading='btnLoading' style="margin: 0 auto;" v-if="num!=allData.questionList.length - 1" @click="closeDia">下一题</el-button>
        <el-button class="btn next elb" :loading='btnLoading' style="margin: 0 auto;"  v-else @click="querySubmit">交 卷</el-button>
      </div>
    </el-dialog>
    <el-dialog  :visible.sync="dialogVisible" class="dia" :show-close='false' :close-on-click-modal='false' :close-on-press-escape='false'  width='400px'>
      <span>考试时间已到，系统将自动为您交卷</span>
      <span slot="footer" class="dialog-footer btn-wrap">
        <el-button class="btn next elb" :loading='btnLoading' style="margin: 0 auto;"   @click="querySubmit(1)">交 卷</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
import debounce from 'lodash/debounce'
export default {
  name: 'exam',
  data () {
    return {
      allData: {},
      minioUrl: '',
      headUrl: require('@/assets/img/face_nomal.png'),
      num: 0,
      minutes: 59, // 分
      seconds: 59, // 秒
      duration: 0,
      istrue: false,
      boxLoading: false,
      sinAnswer: [],
      selXx: '',
      answerSheet: [],
      examPaperId: '',
      examPaperName: '',
      visible: false,
      answerLoading: false,
      dialogVisible: false,
      btnLoading: false,
      isEndt: false,
      points: 0,
      Allduration: '',
      user: {},
      libraryId: '',
      ksType: '模拟考试',
      type: 1,
      tName: '',
      times: ''
    }
  },
  components: {},
  computed: {
    // 倒计时
    second: function () {
      return this.isTimeZero(this.seconds)
    }
  },
  watch: {
    // 倒计时
    second: {
      handler (newVal) {
        this.isTimeZero(newVal)
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    // 倒计时
  },
  methods: {
    moment,
    init () {
      this.minioUrl = process.env.VUE_APP_minio
      this.getLibrary()
    },
    queFomate (val) {
      if (val === '1') {
        return '单项选择题'
      }
      if (val === '2') {
        return '多项选择题'
      }
      if (val === '3') {
        return '判断题'
      }
    },
    tagFomate (val) {
      if (val === '1') {
        return ''
      }
      if (val === '2') {
        return 'warning'
      }
      if (val === '3') {
        return 'success'
      }
    },
    getLibrary () {
      this.boxLoading = true
      const loading = this.$loading({
        lock: true,
        text: '加载考试中...',
        spinner: 'el-icon-loading'
      })
      this.user = JSON.parse(localStorage.getItem('user'))

      this.libraryId = this.$route.query.libraryId
      let obj = { userId: this.user.id, libraryId: this.libraryId }
      this.$post('/client/exam/onlineExam', obj).then((res) => {
        loading.close()
        this.boxLoading = false
        if (res.code !== 0) {
          window.history.go(-1)
        }
        if (res.data.flag === 'false') {
          this.$message.error(res.data.msg)
          window.history.go(-1)
        }
        if (
          moment(res.data.endDate).isBefore(res.data.nowDate)
        ) {
          this.allData = res.data
          this.minutes = 0
          this.seconds = '0'
          this.dialogVisible = true
        } else {
          this.allData = res.data
          this.minutes = res.data.duration - 1
          this.duration = res.data.duration
          // console.log(moment(res.data.nowDate).isBefore(res.data.endDate))
          this.timer()
        }

        // startDate
        // nowDate
        // endDate

        if (
          moment(res.data.nowDate).isBefore(res.data.endDate) && res.data.isFirst !== 1
        ) {
          // 服务器时间大于截止时间
          var a = Date.parse(res.data.nowDate.replace(/-/g, '/'))
          var b = Date.parse(res.data.endDate.replace(/-/g, '/'))
          var duration = b - a
          this.minutes = this.moment(duration).minutes()
          this.seconds = this.moment(duration).seconds()
          // this.timer()
        }
        this.num = res.data.finishNum
          ? res.data.finishNum === this.allData.questionList.length
            ? res.data.finishNum - 1
            : res.data.finishNum
          : 0
      })
    },
    // 点击下一题
    next () {
      this.pushAnswer()
      this.visible = true
    },

    closeDia: debounce(function () {
      let allNum = this.allData.questionList.length - 1
      if (this.num !== allNum) {
        this.num++
      }
      // if (this.num === allNum) {
      //   this.isEndt = true
      // }
      this.sinAnswer = []
      this.visible = false
    }
    , 1000, { 'leading': true, 'trailing': false }),
    pushAnswer () {
      // finishNum
      // client/exam/questionVerify
      console.log(this.answerSheet[this.num])
      this.answerLoading = true
      const obj = {
        libraryId: this.libraryId,
        userId: this.user.id,
        questionId: this.answerSheet[this.num].examQuestionId,
        paperId: this.allData.paperId,
        questionType: this.answerSheet[this.num].questionType,
        answer: this.answerSheet[this.num].answer,
        finishNum: this.num + 1
      }
      this.$post(`/client/exam/questionVerify`, obj)
        .then((res) => {
          this.answerLoading = false
          if (res.code !== 0) {
            return false
          }
          this.istrue = res.data === '1'
          // this.$message({
          //   message: `回答${res.data === '1' ? '正确' : '错误'}`,
          //   type: res.data === '1' ? 'success' : 'error'
          // })
        })
        .catch(() => {})
    },
    // 切换题
    selTiClick (index) {
      this.num = index
      this.sinAnswer = []
    },
    // 倒计时
    isTimeZero (n) {
      return n < 10 ? '0' + n : '' + n
    },
    // 倒计时
    timer () {
      const _this = this
      const time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59
          _this.minutes -= 1
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          // 倒计时结束结束考试
          _this.seconds = 0
          _this.dialogVisible = true
          window.clearInterval(time)
        } else {
          _this.seconds -= 1
        }
      }, 1000)
    },
    // 选择选项
    queryAnswer (index, item, selAnswer) {
      console.log(item, selAnswer)
      var answerSheet = this.answerSheet[index]
      if (answerSheet === undefined) {
        answerSheet = {}
      }
      if (item.questionType === '1') {
        // 单选
        this.sinAnswer = selAnswer
        answerSheet['answer'] = selAnswer
        answerSheet['examQuestionId'] = item.id
        answerSheet['questionType'] = item.questionType
        answerSheet['isRight'] = item.answer === selAnswer ? 1 : 0
        answerSheet['points'] =
          answerSheet.isRight === 1 ? Number(item.points) : 0
      }
      if (item.questionType === '2') {
        // 多选
        if (this.sinAnswer.indexOf(selAnswer) > -1) {
          this.sinAnswer.splice(this.sinAnswer.indexOf(selAnswer), 1)
        } else {
          this.sinAnswer.push(selAnswer)
        }
        let arr = []
        this.sinAnswer.map((item) => {
          if (item === 'A') {
            arr.push(1)
          }
          if (item === 'B') {
            arr.push(2)
          }
          if (item === 'C') {
            arr.push(3)
          }
          if (item === 'D') {
            arr.push(4)
          }
        })
        let pushArr = []
        arr.sort().map((item) => {
          if (item === 1) {
            pushArr.push('A')
          }
          if (item === 2) {
            pushArr.push('B')
          }
          if (item === 3) {
            pushArr.push('C')
          }
          if (item === 4) {
            pushArr.push('D')
          }
        })
        // this.sinAnswer = pushArr.join(',')
        answerSheet['answer'] = pushArr.join(',')
        answerSheet['examQuestionId'] = item.id
        answerSheet['questionType'] = item.questionType
        answerSheet['isRight'] = item.answer === answerSheet.answer ? 1 : 0
        answerSheet['points'] =
          answerSheet.isRight === 1 ? Number(item.points) : 0
      }
      if (item.questionType === '3') {
        // 单选
        this.sinAnswer = selAnswer
        answerSheet.answer = selAnswer
        answerSheet.examQuestionId = item.id
        answerSheet['questionType'] = item.questionType
        answerSheet.isRight = item.answer === answerSheet.answer ? 1 : 0
        answerSheet.points = answerSheet.isRight === 1 ? Number(item.points) : 0
      }
      this.answerSheet[index] = answerSheet
    },
    // 考试时间到，自动提交试卷
    querySubmit: debounce(function (type) {
      if (!type) { this.pushAnswer() }
      this.dialogVisible = false
      this.querySubmitData()
    }
    , 1000, { 'leading': true, 'trailing': false }),
    // 确认提交考卷
    querySubmitData () {
      this.btnLoading = true
      let obj = {
        libraryId: this.libraryId,
        paperId: this.allData.paperId,
        userId: this.user.id
      }
      this.$post(`/client/exam/papersSubmit`, obj)
        .then((res) => {
          this.btnLoading = false
          this.$router.replace({
            name: 'testResults',
            query: obj
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.box {
  min-height: calc(100vh - 140px);
  background: #f7f7f7;
  overflow: hidden;
}
.content-body {
  width: 1200px;
 height: calc(100vh - 160px);
  margin: 0 auto;
  margin-top: 20px;
  /* background: #fff; */
  box-sizing: border-box;
  /* padding-top: 54px; */
  overflow: hidden;
}
.left {
  margin-right: 20px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.op-item {
  cursor: pointer;
}
.left .user-info {
  height: 60vh;
  padding: 20px 16px;
  margin-top: 12px;
  margin-bottom: 22px;
  background: white;
}
.left .kt,
.left .user-info {
  width: 180px;
  /* border: 1px solid #ddd; */
  box-sizing: border-box;
}
.pos {
  position: relative;
}
.pos .tit {
  /* position: absolute; */
  /* top: -17px; */
  left: 32px;
  /* background: #fff; */
  padding: 5px;
  font-size: 14px;
  color: #333;
  padding-top: 20px;
  line-height: 30px;
}
.left .user-info div img {
  display: block;
  width: 100px;
  height: 100px;
  margin: 0 auto 15px;
}
.left .user-info p {
  margin-bottom: 10px;
  font-size: 0;
  color: #4a4a4a;
}
.left .user-info p label.mr {
  margin-right: 32px;
}
.left .user-info p label {
  font-size: 16px;
}
.left .user-info p span {
  font-size: 16px;
}
.left .waste-time {
  width: 180px;
  height: 124px;
  background: linear-gradient(180deg, #679cf6 0%, #4072ee 100%);
  box-sizing: border-box;
  text-align: center;
  /* line-height: 124px; */
  color: #fff !important;
  font-weight: 500;
  font-size: 26px;
}
.center {
  /* margin-right: 20px; */
  user-select: none;
}
.tip {
  margin-top: 14px;
  font-size: 18px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
}
.dialog-footer {
  text-align: center;
}
.center .kstm {
  width: 900px;
  height: 60vh;
  /* border: 1px solid #ddd; */
  /* box-sizing: border-box; */
  background: white;
  padding: 64px 46px;
  margin-bottom: 22px;
}
.center .kstm .name,
.center .kstm .option p {
  color: #4a4a4a;
  font-size: 18px;
  margin-bottom: 15px;
}
.center .kstm .tm-answer .aswer span {
  font-size: 18px;
  line-height: 25px;
  color: #4a4a4a;
}
.center .kstm .name {
  line-height: 30px;
  letter-spacing: 1px;
}
.center .kstm .tag {
  position: relative;
  top: -3px;
}
.center .kstm .option p {
  line-height: 21px;
}
.center .kstm .tm-answer {
  width: 100%;
  overflow: hidden;
  margin-top: 60px;
  box-sizing: border-box;
}
.center .kstm .tm-answer .sec-aswer {
  font-size: 18px;
  line-height: 25px;
  color: #4a4a4a;
}
.center .kstm .tm-answer .aswer {
  overflow: hidden;
}
.imgCon{
  width: 100px;
  height: 100px;
  margin: 0 auto 15px;
  border-radius: 50%;
  overflow: hidden;
}
.center .kstm .tm-answer .aswer li {
  float: left;
  min-width: 65px;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  border: 1px solid #ccc;
  margin: 0 5px;
  background: #fff;
  transition: all 0.3s ease-in-out;
  border-radius: 3px;
  text-align: center;
  cursor: pointer;
}
.center .tsxx {
  width: 318px;
  height: 70px;
  padding: 16px 10px 10px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 22px;
}
.center .btn-wrap {
  padding: 35px 0;
  /* margin-left: 10px; */
}
.btn-wrap .btn {
  width: 120px;
  height: 32px;
  line-height: 32px;
  background: #2977ee;
  border-radius: 4px;
  display: block;
  color: white;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}
.btn-wrap .elb{
  line-height: 8px;
}
.right {
  width: 330px;
}
.right .Qn-wrap {
  overflow: hidden;
}
.right .Qn-wrap li.noSel {
  line-height: 40px;
}

.right .Qn-wrap li.active {
  background: #409eff;
}
.right .Qn-wrap li.active p {
  color: white;
}
.right .Qn-wrap li {
  width: 40px;
  height: 40px;
  color: #4a4a4a;
  font-size: 13px;
  border: 1px solid #eee;
  text-align: center;
  float: left;
  box-sizing: border-box;
  cursor: pointer;
}
.xuanSel {
  background: #2977ee;
  color: white;
  transition: all 0.3s linear;
  border: 1px solid #2977ee !important;
}
.dia /deep/ .el-dialog{
  border-radius: 12px;
}
</style>
